import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import approval from './localOpportunities/approvalReducers'
import profileLoad from './localOpportunities/intakeReducers'
import notes from './localOpportunities/notesReducers'
import contacts from './localOpportunities/contactsReducers'

import * as h2Api from '../h2Api'
import {
  ADMIN_PROFILE_CONTACT_SAVED,
  ADMIN_PROFILE_NOTES_SAVED,
  initialLocalOpportunityContactModel
} from '../actions/admin/adminLocalOpportunityActions'
import {
  COMPANY_LOAD,
  companyIntakeModel,
  CONTACT_LOOKUP_EMAIL,
  CONTACT_LOOKUP_RECORD,
  CONTACT_SAVE_RECORD,
  contactIntakeModel,
  participationIntakeModel,
  RETRIEVE_CLUSTERS
} from '../actions/localopportunities/localopportunities'
import { APPLY_FOR_PROFILE, LOAD_WBL_TYPES } from '../actions/profileViewActions'

const initialNoteModel = {
  note: '',
  file: {}
}
const initialEmailLookupModel = {
  email: ''
}
const userInterestExpressionModel = {
  applicationNotes: '',
  topClusterId: ''
}
const initialAssignAndApproveModel = {
  assignTo: ''
}
const initialRejectionModel = {
  comment: ''
}
const reducers = combineReducers({
  approval,
  notes,
  contacts,
  profileLoad,
  lookupEmailRequest: h2Api.restReducer(CONTACT_LOOKUP_EMAIL),
  lookupUpdateRecordRequest: h2Api.restReducer(CONTACT_LOOKUP_RECORD),
  noteFormRequest: h2Api.restReducer(ADMIN_PROFILE_NOTES_SAVED),
  contactIntakeRequest: h2Api.restReducer(CONTACT_SAVE_RECORD),
  contactFormRequest: h2Api.restReducer(ADMIN_PROFILE_CONTACT_SAVED),
  userInterestExpressionRequest: h2Api.restReducer(APPLY_FOR_PROFILE),
  companyProfileRequest: h2Api.restReducer(COMPANY_LOAD),
  wblTypes: h2Api.restReducer(LOAD_WBL_TYPES),
  noteCreationForm: modelReducer('localOpportunities.noteCreationForm', initialNoteModel),
  contactCreationForm: modelReducer(
    'localOpportunities.contactCreationForm',
    initialLocalOpportunityContactModel
  ),
  lookupEmailForm: modelReducer(
    'localOpportunities.lookupEmailForm',
    initialEmailLookupModel
  ),
  rejectApplicationForm: modelReducer(
    'localOpportunities.rejectApplicationForm',
    initialRejectionModel
  ),
  assignAndApproveForm: modelReducer(
    'localOpportunities.assignAndApproveForm',
    initialAssignAndApproveModel
  ),
  contactIntakeForm: modelReducer(
    'localOpportunities.contactIntakeForm',
    contactIntakeModel
  ),
  contactCompanyIntakeForm: modelReducer(
    'localOpportunities.contactCompanyIntakeForm',
    companyIntakeModel
  ),
  contactParticipationIntakeForm: modelReducer(
    'localOpportunities.contactParticipationIntakeForm',
    participationIntakeModel
  ),
  userInterestExpressionForm: modelReducer(
    'localOpportunities.userInterestExpressionForm',
    userInterestExpressionModel
  ),
  userInterestExpressionClustersRequest: h2Api.restReducer(RETRIEVE_CLUSTERS),
  forms: formReducer('localOpportunities', {
    noteCreationForm: initialNoteModel,
    contactCreationForm: initialLocalOpportunityContactModel,
    contactCompanyIntakeForm: companyIntakeModel,
    contactParticipationIntakeForm: participationIntakeModel,
    rejectApplicationForm: initialRejectionModel,
    userInterestExpressionForm: userInterestExpressionModel,
    assignAndApproveForm: initialAssignAndApproveModel,
    contactIntakeForm: contactIntakeModel
  })
})

export default reducers
